export const API_BASE_URL = process.env.REACT_APP_API_URL || "https://kastra.postscriptum.gr/api";

const API_URLS = {
  GET_ALL_CASTLES: `${API_BASE_URL}/castles`,
  GET_CASTLE: (castleId) => `${API_BASE_URL}/castles/${castleId}`,
  GET_CASTLE_QUESTIONS: (castleId, difficulty, set) =>
    `${API_BASE_URL}/castles/${castleId}/questions?difficulty=${difficulty}&set=${set}`,
};

export default API_URLS;